import React, { createContext, useContext, useState } from 'react';

const SwitchContext = createContext(null);

export const SwitchProvider = ({ children }) => {
  const [override, setOverride] = useState(null);
  return (
    <SwitchContext.Provider value={{ override, setOverride }}>
      {children}
    </SwitchContext.Provider>
  );
};

export const useSwitch = () => useContext(SwitchContext);
